import { createContext } from 'react';

import type { TranslateFn } from '@/shared/utils/format-date.js';

type StoreHook = <S>(selector: (s: any) => S) => S;

export interface AppContextValue {
    translate: TranslateFn;
    useAuthStore: StoreHook;
    useProjectStore: StoreHook;
    useThemeStore: StoreHook;
}

export const AppContext = createContext<AppContextValue | null>(null);
